import axios from "axios"
import store from '@/store';
import router from "@/router";

// load system config file

/*var config;
var xhr = new XMLHttpRequest();
xhr.open('GET', "/config.json", false);
xhr.onload = function() {
	var status = xhr.status;
	if (status === 200) {
		config = JSON.parse(xhr.response)
	}
};
xhr.send();*/

// load system config file

const config = require('../../public/config.json');
let baseDomain = '';
if (window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1')) {
	baseDomain = config.baseDomain.local;
} else if (window.location.host == "optimark.dev.optimi.dev") {
	baseDomain = config.baseDomain.dev;	
} else if (window.location.host == "optimark.staging.optimi.dev") {
	baseDomain = config.baseDomain.staging;
} else {
	baseDomain = config.baseDomain.live;
}

// set up base URL

//const baseURL = config.baseDomain + config.baseUrl;
const baseURL = baseDomain + config.baseUrl;

// intialize axios

const instance = axios.create({
	baseURL,
	withCredentials: true,
});

let isRefreshing = false; // this holds any in-progress token refresh requests
let refreshSubscribers = [];

function subscribeTokenRefresh(cb) {
	refreshSubscribers.push(cb);
}
  
function onRefreshed(token) {
	refreshSubscribers.map(cb => cb(token));
	refreshSubscribers = [];
}

// create an interceptor to add authentication token to each request

instance.interceptors.request.use(function(config) {
	const token = store.state.auth.token;
	if (token) {
		config.headers.Authorization = 'Bearer ' + store.state.auth.token;
	}
	return config;	
  }, function(err) {
	return Promise.reject(err);
  }
);
  
// create an interceptor to catch and handle 401 responses

instance.interceptors.response.use(function (response) {
	// console.log("Debug response:", response);
	response.loaded = true
	return response;
}, async function (error) {
	try {
		const { config, response: { status } } = error;
		const originalRequest = config;

		if (status === 400) { // bad request

			// ignore bad request response, and pass response object onto UI to handle

			return error.response;

		} else if (status === 401) {

			const retryOrigReq = new Promise((resolve, reject) => {
				subscribeTokenRefresh(token => {
					// replace the expired token and retry
					originalRequest.headers['Authorization'] = 'Bearer ' + token;
					resolve(axios(originalRequest));
				});
			});

			if (!isRefreshing) {
				isRefreshing = true;

				var { data } = await instance.post('User/RefreshToken', {});

				if (data.success === true) {
					isRefreshing = false;
					// update refreshed token in store
					store.commit("refreshToken", data.data.token);

					onRefreshed(data.data.token);
				} else {
					refreshSubscribers = [];
					store.commit("signOut");
					router.push("/login");
				}
			}

			return retryOrigReq;

		} else if (status === 403) {

			return { 
				data: { 
					success: false, 
					error: { 
						message: "Unauthorized access." 
					}
				}
			}

		} else if (status === 404) {

			return { 
				data: { 
					success: false, 
					error: { 
						message: "Page not found." 
					}
				}
			}

		} else {
			return { 
				data: { 
					success: false, 
					error: { 
						message: "Server Error: Please wait a moment and then try again." 
					}
				}
			}
		}
	} catch (error) {
		//console.error("Network Error")
		return { 
			data: { 
				success: false, 
				error: { 
					message: "Network Error: Can not connect to the internet" 
				}
			}
		}
	}
	

});

export default instance
